export default "dea966fd7555985f.png"